;(function () {
  'use strict';

  var cardSelector = '.t4s-product, .femily-product-card';
  var boundAttribute = 'data-femily-grid-loading-bound';

  function idle(callback) {
    if (window.requestIdleCallback) {
      window.requestIdleCallback(callback, { timeout: 900 });
    } else {
      window.setTimeout(callback, 0);
    }
  }

  function loadImage(image) {
    if (!image || image.getAttribute('data-femily-held') !== 'true') return;
    var src = image.getAttribute('data-femily-src');
    var srcset = image.getAttribute('data-femily-srcset');
    if (src) image.setAttribute('data-src', src);
    if (srcset) image.setAttribute('data-srcset', srcset);
    image.removeAttribute('data-femily-src');
    image.removeAttribute('data-femily-srcset');
    image.removeAttribute('data-femily-held');
    image.classList.add('lazyloadt4s');

    var lazyLoader = window.lazySizesT4 || window.lazySizes;
    if (lazyLoader && lazyLoader.loader && lazyLoader.loader.unveil) {
      lazyLoader.loader.unveil(image);
    }
  }

  function releaseCardImages(card) {
    card.querySelectorAll('img[data-femily-held="true"]').forEach(loadImage);
  }

  function holdSecondaryImage(card) {
    var image = card.querySelector('img[data-pr-img2]');
    if (!image || image.getAttribute('data-femily-held') === 'true') return;
    if (image.currentSrc && image.currentSrc.indexOf('data:image') !== 0) return;

    var src = image.getAttribute('data-src');
    if (!src) return;

    image.setAttribute('data-femily-src', src);
    image.removeAttribute('data-src');

    var srcset = image.getAttribute('data-srcset');
    if (srcset) {
      image.setAttribute('data-femily-srcset', srcset);
      image.removeAttribute('data-srcset');
    }

    image.setAttribute('data-femily-held', 'true');

    var primary = card.querySelector('img[data-pr-img]');
    var release = function () { idle(function () { loadImage(image); }); };
    if (primary && primary.complete && primary.naturalWidth > 0) {
      release();
    } else if (primary) {
      primary.addEventListener('load', release, { once: true, passive: true });
    }
  }

  function bindCard(card) {
    if (card.getAttribute(boundAttribute) === 'true') {
      holdSecondaryImage(card);
      return;
    }
    card.setAttribute(boundAttribute, 'true');
    card.addEventListener('pointerenter', function () { releaseCardImages(card); }, { passive: true });
    card.addEventListener('touchstart', function () { releaseCardImages(card); }, { passive: true });
    holdSecondaryImage(card);
  }

  function scanNode(node) {
    if (!node || node.nodeType !== 1) return;
    if (node.matches(cardSelector)) bindCard(node);
    var parentCard = node.closest && node.closest(cardSelector);
    if (parentCard) bindCard(parentCard);
    node.querySelectorAll(cardSelector).forEach(bindCard);
    node.querySelectorAll('img[data-pr-img2]').forEach(function (image) {
      var card = image.closest(cardSelector);
      if (card) bindCard(card);
    });
  }

  scanNode(document.documentElement);
  new MutationObserver(function (records) {
    records.forEach(function (record) {
      record.addedNodes.forEach(scanNode);
    });
  }).observe(document.documentElement, { childList: true, subtree: true });
}());